import {IconProps} from "../../../types/IconProps";
import "./whatsapp-check.css";

const WhatsappDoubleCheck = ({ width = 800, height = 800, color = '#000'}: IconProps) => {
    return (
        <div className="double-check-container">
            <svg width={`${width}px`} height={`${height}px`} version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"  xmlSpace="preserve">
                <g>
                    <path className="st0" fill={color} d="M469.402,35.492C334.09,110.664,197.114,324.5,197.114,324.5L73.509,184.176L0,254.336l178.732,222.172
                        l65.15-2.504C327.414,223.414,512,55.539,512,55.539L469.402,35.492z"/>
                </g>
            </svg>
            <svg width={`${width}px`} height={`${height}px`} version="1.1" id="_x32_" xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" viewBox="0 0 512 512"  xmlSpace="preserve">
                <g>
                    <path className="st0" fill='#dbdbdb' d="M469.402,35.492C334.09,110.664,197.114,324.5,197.114,324.5L73.509,184.176L0,254.336l178.732,222.172
                    l65.15-2.504C327.414,223.414,512,55.539,512,55.539L469.402,35.492z"/>
                </g>
            </svg>
        </div>
    )
}

export default WhatsappDoubleCheck;